import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Card, Dropdown, LILAC_400, LILAC_500, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { View } from 'react-native';
import { PackCardWidgetComponent as PackCardWidget } from '../../../pack-card-widget/PackCardWidget';
import ComparePlanBenefitList from '../compare-benefit-list/CompareBenefitList';
import { AccordionListWidgetComponent as AccordionListWidget } from '../../../accordion-list-widget/AccordionListWidget';
import { getComparePlanCardStyles } from './ComparePlanCardStyles';
import { useEffect, useState } from 'react';
import { getSelectedPlan } from '../../ComparisonViewCardWidgetUtils';
var ComparePlanCard = props => {
  var _a, _b, _c, _d;
  var _props$selectedDropdo = props.selectedDropdownList,
    selectedDropdownList = _props$selectedDropdo === void 0 ? {} : _props$selectedDropdo,
    _props$dropDownDetail = props.dropDownDetails,
    dropDownDetails = _props$dropDownDetail === void 0 ? {} : _props$dropDownDetail,
    _props$showEmptyInfoT = props.showEmptyInfoTagContainer,
    showEmptyInfoTagContainer = _props$showEmptyInfoT === void 0 ? false : _props$showEmptyInfoT,
    planDetailsList = props.planDetailsList,
    onUserAction = props.onUserAction,
    onPlanSelected = props.onPlanSelected,
    showListSubtitleSection = props.showListSubtitleSection,
    listTitleSectionProps = props.listTitleSectionProps,
    _props$showDropDown = props.showDropDown,
    showDropDown = _props$showDropDown === void 0 ? true : _props$showDropDown,
    _props$isTableView = props.isTableView,
    isTableView = _props$isTableView === void 0 ? false : _props$isTableView,
    _props$isLastVertical = props.isLastVerticalItem,
    isLastVerticalItem = _props$isLastVertical === void 0 ? false : _props$isLastVertical,
    _props$isLastHorizont = props.isLastHorizontalItem,
    isLastHorizontalItem = _props$isLastHorizont === void 0 ? false : _props$isLastHorizont,
    selectedPlanValue = props.selectedPlanValue,
    style = props.style,
    cardStyle = props.cardStyle,
    cardBackgroundColor = props.cardBackgroundColor,
    _props$updatePlanValu = props.updatePlanValueFromDropdown,
    updatePlanValueFromDropdown = _props$updatePlanValu === void 0 ? true : _props$updatePlanValu,
    cardBorderColor = props.cardBorderColor,
    onMountMetaData = props.onMountMetaData,
    _props$cardNoPadding = props.cardNoPadding,
    cardNoPadding = _props$cardNoPadding === void 0 ? false : _props$cardNoPadding,
    index = props.index,
    id = props.id,
    theme = props.theme,
    testID = props.testID;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var comparePlanCardStyles = getComparePlanCardStyles(props);
  var _ref = dropDownDetails || {},
    dropdownList = _ref.dropdownList,
    onDropDownSelectionMetaData = _ref.onDropDownSelectionMetaData;
  var removeSelectedValueFromDropdown = Object.keys(selectedDropdownList).length > 0;
  var getValuesExcludingKey = (obj, keyToExclude) => {
    var _a, _b;
    return (_b = (_a = Object.entries(obj)) === null || _a === void 0 ? void 0 : _a.filter(_ref2 => {
      var key = _ref2[0];
      return parseInt(key) !== keyToExclude;
    })) === null || _b === void 0 ? void 0 : _b.map(_ref3 => {
      var _ = _ref3[0],
        value = _ref3[1];
      return value;
    });
  };
  var filterDropdownExcludingValue = () => {
    var _a;
    return (_a = Object.values(dropdownList)) === null || _a === void 0 ? void 0 : _a.filter(item => !excludingValue.includes(item === null || item === void 0 ? void 0 : item.value));
  };
  var excludingValue = (_a = getValuesExcludingKey(selectedDropdownList, index)) !== null && _a !== void 0 ? _a : [];
  var filteredDropdown = (dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList.length) > 0 && filterDropdownExcludingValue();
  var value = (_b = selectedDropdownList[index]) !== null && _b !== void 0 ? _b : dropDownDetails.value;
  var _useState = useState((selectedPlanValue === null || selectedPlanValue === void 0 ? void 0 : selectedPlanValue[index]) || ((_c = dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList[0]) === null || _c === void 0 ? void 0 : _c.value)),
    selectedPack = _useState[0],
    setSelectedPack = _useState[1];
  var handleDropDownSelection = data => {
    var _a, _b, _c, _d, _e;
    onDropDownSelectionMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onDropDownSelectionMetaData), Object.assign({}, data[0])));
    if (updatePlanValueFromDropdown) {
      setSelectedPack(((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.value) || selectedPlanValue[index] || ((_b = dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList[0]) === null || _b === void 0 ? void 0 : _b.value));
      var selectedPlan = [...selectedPlanValue];
      selectedPlan[index] = ((_c = data === null || data === void 0 ? void 0 : data[0]) === null || _c === void 0 ? void 0 : _c.value) || (selectedPlanValue === null || selectedPlanValue === void 0 ? void 0 : selectedPlanValue[index]) || ((_d = dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList[0]) === null || _d === void 0 ? void 0 : _d.value);
      onPlanSelected(selectedPlan, index, (_e = data === null || data === void 0 ? void 0 : data[0]) === null || _e === void 0 ? void 0 : _e.value);
    }
  };
  useEffect(() => {
    onMountMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onMountMetaData), Object.assign(Object.assign({}, props), {
      index
    })));
  }, []);
  useEffect(() => {
    var _a;
    setSelectedPack((selectedPlanValue === null || selectedPlanValue === void 0 ? void 0 : selectedPlanValue[index]) || ((_a = dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList[0]) === null || _a === void 0 ? void 0 : _a.value));
  }, [selectedPlanValue]);
  var selectedPlanDetails = getSelectedPlan(planDetailsList, selectedPack);
  var _ref4 = selectedPlanDetails || {},
    planCardDetails = _ref4.planCardDetails,
    benefitsListData = _ref4.benefitsListData,
    accordionList = _ref4.accordionList;
  var _ref5 = benefitsListData || {},
    _ref5$showExpandCta = _ref5.showExpandCta,
    showExpandCta = _ref5$showExpandCta === void 0 ? false : _ref5$showExpandCta,
    benefitsList = _ref5.benefitsList,
    expandCTAData = _ref5.expandCTAData;
  var _leftCTAProps = Object.assign({
    size: isLargeScreen ? 'md' : 'sm'
  }, (_d = planCardDetails === null || planCardDetails === void 0 ? void 0 : planCardDetails.buttonWidgetData) === null || _d === void 0 ? void 0 : _d.leftCta);
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [comparePlanCardStyles.comparePlanCardWrapper, style]
  }, {
    children: [showDropDown && (_createElement(Dropdown, Object.assign({
      style: [comparePlanCardStyles.dropdown, dropDownDetails === null || dropDownDetails === void 0 ? void 0 : dropDownDetails.style]
    }, dropDownDetails, {
      value: value,
      dropdownList: removeSelectedValueFromDropdown ? filteredDropdown : dropdownList,
      onSelectedHandler: data => handleDropDownSelection(data),
      id: id,
      key: removeSelectedValueFromDropdown ? Math.random().toString() : value
    }, getTestId(testID, 'dropDown')))), _jsxs(Card, Object.assign({
      style: [comparePlanCardStyles.planDetailsContainer, cardStyle],
      borderColor: isTableView ? LILAC_500 : cardBorderColor
    }, (cardBackgroundColor || isTableView) && {
      backgroundColor: cardBackgroundColor ? cardBackgroundColor : LILAC_400
    }, {
      noPadding: isTableView ? true : cardNoPadding,
      showShadow: false
    }, getTestId(testID, 'planDetailsContainer'), {
      children: [!!planCardDetails && Object.keys(planCardDetails).length > 0 && _jsx(PackCardWidget, Object.assign({
        hideDivider: true,
        hideOttText: true,
        hideRightChevronIcon: true,
        showEmptyInfoTagContainer: showEmptyInfoTagContainer,
        id: id,
        style: [comparePlanCardStyles.planDetailsStyle, Object.assign({}, !!(planCardDetails === null || planCardDetails === void 0 ? void 0 : planCardDetails.buttonWidgetData) && comparePlanCardStyles.planCardBottomCta), planCardDetails === null || planCardDetails === void 0 ? void 0 : planCardDetails.style],
        cardStyle: comparePlanCardStyles === null || comparePlanCardStyles === void 0 ? void 0 : comparePlanCardStyles.planDetailsCard,
        onUserAction: onUserAction,
        buttonWidgetData: Object.assign(Object.assign({}, planCardDetails === null || planCardDetails === void 0 ? void 0 : planCardDetails.buttonWidgetData), {
          leftCta: _leftCTAProps
        })
      }, planCardDetails, getTestId(testID, 'planCardDetails'))), !!benefitsListData && Object.keys(benefitsListData).length > 0 && _jsx(ComparePlanBenefitList, Object.assign({
        id: id,
        data: benefitsList,
        showExpandCta: showExpandCta,
        expandCtaData: expandCTAData,
        isTableView: isTableView,
        showBottomLeftRadius: isLastVerticalItem && index == 0,
        showBottomRightRadius: isLastVerticalItem && isLastHorizontalItem,
        onUserAction: onUserAction
      }, benefitsListData, {
        theme: theme
      }, getTestId(testID, 'benefitsList'))), !!accordionList && (accordionList === null || accordionList === void 0 ? void 0 : accordionList.length) > 0 && _jsx(AccordionListWidget, Object.assign({
        data: accordionList,
        onUserAction: onUserAction,
        showListSubtitleSection: showListSubtitleSection,
        listTitleSectionProps: listTitleSectionProps
      }, getTestId(testID, 'accordionList')))]
    }))]
  }));
};
export default ComparePlanCard;